import { Close, Done } from "@mui/icons-material"
import { Grid, Stack, Typography, useMediaQuery, useTheme } from "@mui/material"
import CustomCard from "components/CustomCard"
import { METER_TYPE } from "config/const"
import { findKeyByValue } from "config/functions"
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation"

const ReadToday = ({ data }) => {
  const theme = useTheme()
  const { bt } = useBizTypeTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <CustomCard
      width={isMobile ? '100%' : "60%"}
      border='1px solid #000'
      alignItems='center'
      padding={1}
    >
      <Typography fontWeight='bold'>{bt('READ_TODAY')}</Typography>
      <Grid container>
        {data?.meters?.map((meter, idx) => {
          return (
            <Grid item xs={6} md={4} xl={3}>
              <Stack
                direction='row'
                color={meter?.hasReadToDay ? 'success.main' : 'error.text'}
                key={idx}
                minWidth={100}
                spacing={0.1}
                padding={isMobile ? 0.5 : 1}
              >
                {meter?.hasReadToDay
                  ? <Done sx={{ color: 'success.main' }} />
                  : <Close sx={{ color: 'error.text' }} />
                }
                <Typography
                  color={meter?.hasReadToDay ? 'success.main' : 'error.text'}
                  fontSize={{ xs: 14, md: 16 }}
                >
                  {`${bt(findKeyByValue(METER_TYPE, meter?.type))} (${meter?.name})`}
                </Typography>
              </Stack>
            </Grid>
          )
        })}
      </Grid>
    </CustomCard>

  )
}

export default ReadToday